import { render, staticRenderFns } from "./StaffManagementIndex.vue?vue&type=template&id=442ae272"
import script from "./StaffManagementIndex.vue?vue&type=script&lang=js"
export * from "./StaffManagementIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports